import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import EventEmitter from 'EventEmitter';
import ProductHelpers from 'webshop/js/product-helpers';
import { onCheckoutOption, sendEnhancedAnalytics } from 'webshop/js/analytics';

import 'jgrowl/jquery.jgrowl';

const emptyBlankChoices = () => {
  $('#et-choices').empty();
  $('#pcd-choices').empty();
  $('#bore-choices').empty();
};

function getFormData($form){
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};
    $.map(unindexed_array, function(n, i){
        indexed_array[n['name']] = n['value'];
    });
    return indexed_array;
}

const blankDialog = (formData, action) => {
  // 1. fetch wheel choices
  const productId = formData.split('&')[0].split('=')[1];
  $.getJSON(`/_ajax/products/${productId}/blank_choices`).then(data => {
    var dialog = $( "#blank-dialog" ).dialog({
        autoOpen: false,
        height: 700,
        width: 650,
        modal: true,
        buttons: {
            "Lisää ostoskoriin": () => {
              const isAllSelected = () => {
                const formData = $('#blank-dialog-form').serializeArray();
                if (data.blank_choices.et_choices && !formData.some(d => d.name == 'et_selection')) {
                  return false;
                }
                if (data.blank_choices.pcd_choices && !formData.some(d => d.name == 'pcd_selection')) {
                  return false;
                }
                if (data.blank_choices.bore_choices && !formData.some(d => d.name == 'bore_selection')) {
                  return false;
                }
                return true;
              }

              if (!isAllSelected()) {
                alert('Valitse kaikki vaihtoehtot')
              } else {
                action(getFormData($('#blank-dialog-form')));
                dialog.dialog("close");
                emptyBlankChoices();
              }
            },
            Peruuta: function() {
              dialog.dialog("close");
              emptyBlankChoices();
            }
        },
        close: function() {}
    });
    dialog.dialog('open');

    if (data.blank_choices.et_choices) {
      data.blank_choices.et_choices.map(et => {
        $('#et-title').show();
        $('#et-choices').show();
        $('#et-choices').append(
          `<label><input required name="et_selection" type="radio" value="${et}"/> ${et}</label>`
        );
      });
    } else {
      $('#et-title').hide();
      $('#et-choices').hide();
    }

    if (data.blank_choices.pcd_choices) {
      data.blank_choices.pcd_choices.map(pcd => {
        $('#pcd-title').show();
        $('#pcd-choices').show();
        $('#pcd-choices').append(
          `<label><input required name="pcd_selection" type="radio" value="${pcd}"/> ${pcd}</label>`
        );
      });
    } else {
      $('#pcd-title').hide();
      $('#pcd-choices').hide();
    }

    if (data.blank_choices.bore_choices) {
      data.blank_choices.bore_choices.map(bore => {
        $('#bore-title').show();
        $('#bore-choices').show();
        $('#bore-choices').append(
          `<label><input required name="bore_selection" type="radio" value="${bore}"/> ${bore}</label>`
        );
      });
    } else {
      $('#bore-title').hide();
      $('#bore-choices').hide();
    }
  });
};

export var NavShoppingCart = React.createClass({
    getCount: function (cart) {
        var count = cart.item_count;
        if (cart.shipping) {
            count -= 1;
        }
        return count;
    },
    getInitialState: function () {
        var cart = ShoppingCartManager.getAll().cart;
        return {count: this.getCount(cart), price: cart.total_price_text};
    },
    componentDidMount: function () {
        ShoppingCartManager.on('change', this.update);
    },
    update: function () {
        var cart = ShoppingCartManager.getAll().cart;
        this.setState({
            count: this.getCount(cart),
            total_price: cart.total_price_text
        });
    },
    render: function() {
        return (
            <div className="cart-item-count-wrapper">
                <span className="cart-item-count">{ ~~this.state.count }</span>
            </div>
        );
    }
});

export var ProductAddToCart = React.createClass({
    componentDidMount: function () {
        ShoppingCartManager.on('change', this.update);
        ShoppingCartManager.on('addSuccess', this.updateButton);
    },
    findCartRow: function(rows) {
        return _.findWhere(rows, {product: this.props.id});
    },
    findCartRowData: function(rows) {
        var data = {count: 0, stock_total: 0},
            cartRow = this.findCartRow(rows);
        if (cartRow) {
            data.count = cartRow.count;
            data.stock_total = cartRow.stock_total;
        }
        return data;
    },
    getOptimalCount: function () {
        return ['wheel_set', 'accessory'].includes(this.props.product_type) ? 1 : 4;
    },
    getInitialState: function () {
        var data = ShoppingCartManager.getAll(),
            cart_data = this.findCartRowData(data.rows),
            stock = this.props.non_stock_product ? this.props.supplier_stock : this.props.stock_total,
            count = Math.min(this.getOptimalCount(), stock - cart_data.count);

        if (this.props.delivery_time && !this.props.non_stock_product)
            count = this.getOptimalCount();

        return {
            cart_count: cart_data.count,
            stock_total: this.props.stock_total,
            count: count,
            delivery_time: this.props.delivery_time,
        };
    },
    handleClick: function () {
        this.setState({waitingCartUpdate: true});
        const tireTypes = {
            'summer': 'Kesärenkaat',
            'friction': 'Kitkarenkaat',
            'studded': 'Nastarenkaat',
            'truck': 'KA',
            'work': 'TK',
            'race': 'Kilparenkaat',
            'other': 'Muut renkaat',
        }

        let category = '';
        if (this.props.product_type == 'tire') {
          category = `${tireTypes[this.props.tire_type]}${this.props.used ? ' käytetyt' : ''}`;
        } else if (this.props.product_type == 'accessory') {
          category = 'Tarvikkeet';
        } else {
          category = `${this.props.wheel_type == 'alloy' ? 'Alumiinivanteet' : 'Peltivanteet'}${this.props.used ? ' käytetyt' : ''}`;
        }
        const productData = [{
            'name': this.props.brand + ' ' + this.props.model,
            'id': this.props.id,
            'price': this.props.unit_price,
            'brand': this.props.brand,
            'quantity': parseInt(this.state.count),
            'category': category,
        }];
        dataLayer.push({
          'event': 'ecomAddToCart',
          'ecommerce': {
            'currencyCode': 'EUR',
            'add': {
                'products': productData
            }
          }
        });
        if (this.props.is_blank) {
          blankDialog('id='+this.props.id, (blankData) => {
            ShoppingCartManager.add({
              product: this.props.id,
              count: this.state.count,
              ...blankData,
            });
          });
          this.setState({waitingCartUpdate: false});
        } else {
          ShoppingCartManager.add({
            product: this.props.id,
            count: this.state.count
          });
        }
    },
    update: function () {
        var data = ShoppingCartManager.getAll(),
            cart_data = this.findCartRowData(data.rows),
            cart_count = cart_data.count,
            stock_total = cart_data.stock_total,
            stock = this.props.non_stock_product ? this.props.supplier_stock : this.props.stock_total,
            count = Math.min(this.getOptimalCount(), stock - cart_data.count);
        if (this.props.delivery_time)
            count = this.getOptimalCount();

        // If last stock items was added to cart, redirect to ostoskori
        if (count == 0)
          window.location.href = '/ostoskori/';

        this.setState({
            cart_count: cart_count,
            stock_total: stock_total,
            count: count,
        });
    },
    updateButton: function() {
        this.setState({waitingCartUpdate: false});
    },
    handleCountChange: function(new_count) {
      this.setState({count: new_count});
    },
    render: function () {
        var price = this.props.unit_price_text,
            priceFour = '',
            priceInstalled = '',
            pricePerText = this.props.product_type == 'wheel_set' ? 'sarja':'',
            warningEl,
            addBtn,
            buttonIncDec = '',
            currency = '€';

         if (this.props.product_type == 'wheel' && this.props.non_stock_product) {
            var avail_stock = this.props.supplier_stock - this.state.count;
            price = '';
            pricePerText = '';
            currency = '';
            buttonIncDec = <ProductHelpers.ItemCountControl count={this.state.count}
                                               unitPrice={this.props.unit_price}
                                               interval={2}
                                               max={avail_stock}
                                               pricePerText = 'kpl'
                                               pricePerTextPlural='kpl'
                                               onChange={this.handleCountChange}
                                               extraContainerClass='product-page'/>
        } else if (!['wheel_set', 'accessory'].includes(this.props.product_type)) {
            priceFour = (
                <div className="price-four">
                    {(this.props.unit_price * 4).toFixed(2).replace('.', ',') + '\u00a0€/4\u0020kpl'}
                    {this.props.vat_margin_scheme ? '' : ' (sis. alv ' + window.BASE_VAT +'%)'}
                </div>
            );
        } else if (this.props.product_type == 'accessory') {
          priceFour = (
            <div className="price-four">
                € / kpl
            </div>
          );
        } else {
            priceFour = (
                <div className="price-four">
                    Sis. kaksi etu- ja kaksi takavannetta
                </div>
            );
        }
        if (this.props.product_type == 'tire' && this.props.price_installed && this.props.price_mounting) {
            const price_installed = this.props.price_installed.replace('.', ','),
                  price_mounting = this.props.price_mounting.replace('.', ',');
            priceInstalled = [
                <div className="price-four">{price_installed} €/4 kpl vanteille asennettuna {this.props.vat_margin_scheme ? '' : '(sis. alv ' + window.BASE_VAT +'%)'}</div>,
                <span className="price-four">Auton alle asennus +{price_mounting} €</span>,
            ];
        }
        if (this.state.count > 0 && !this.state.waitingCartUpdate) {
            addBtn = (
                <a className="add-to-cart btn btn-red" onClick={this.handleClick}>
                    OSTA
                </a>
            )
            if (!['wheel_set', 'accessory'].includes(this.props.product_type) && this.state.count < 4) {
                warningEl = (
                    <div className="warning warning-stock-low">
                        Tuotetta jäljellä vain {this.state.count} kpl
                    </div>
                );
            }
        } else if (this.state.waitingCartUpdate) {
            addBtn = <a className="add-to-cart btn btn-red">
                        <i className="fa fa-spinner fa-spin"
                           style={{color: 'white'}}>
                        </i>
                     </a>;
        } else {
            warningEl = (
                <div className="warning warning-stock-empty">
                    Tuote loppu väliaikaisesti.
                </div>
            );
            addBtn = <a className="add-to-cart btn disabled">OSTA</a>;
        }
        if (this.state.delivery_time) {
            warningEl = (
                <div className="warning warning-stock-low">
                Toimitusmyyntituote, toimitusaika {this.state.delivery_time}
                </div>
            );
        }
        let vatDescription = null;
        if (this.props.vat_margin_scheme) {
            vatDescription = (
                <div className="vat-margin-scheme-description">
                  Marginaaliverotusmenettely; tuotteen hinta ei sisällä
                  vähennettävää arvonlisäveroa.
                </div>
            );
        }

        if (this.props.archived) {
          addBtn = <small>Ei saatavilla</small>;
        }

        const unit_price_no_vat_text = this.props.unit_price_no_vat_text

        return (
            <div>
                <div className="prices">
                    {warningEl}
                    <div className="price-texts">
                        {buttonIncDec}
                        <div className="price-big">
                            {price}&nbsp;{currency} {pricePerText}&nbsp;<small>{this.props.vat_margin_scheme ? '' : 'alv ' + window.BASE_VAT +'%'}</small>
                        </div>
                        {!this.props.vat_margin_scheme &&
                            <div className="no-vat-price">
                                {unit_price_no_vat_text}&nbsp;{currency} {pricePerText}&nbsp;<small>alv 0%</small>
                            </div>
                        }
                        {addBtn}
                        {priceFour}
                        {priceInstalled}
                    </div>
                </div>
                {vatDescription}
            </div>
        );
    }
});

var BrandSelect = React.createClass({
    createOption: function(option) {
        return (
            <option key={option.id} value={option.id}>{option.name}</option>
        );
    },
    render: function() {
        const {brand, onChange, options} = this.props;
        return (
            <div className="custom-select">
                <select name="brand" onChange={onChange} defaultValue={brand} >
                    <option value="">Valitse</option>
                    {_.map(_.sortBy(options, el => el.name), this.createOption)}
                </select>
            </div>
        );
    }
});

var ModelSelect = React.createClass({
    createOption: function(option) {
        return (
            <option key={option.id} value={option.id}>{option.name}</option>
        );
    },
    render: function() {
        const {model, onChange, options} = this.props;
        return (
            <div className="custom-select">
                <select name="model" onChange={onChange} defaultValue={model}>
                    <option value="">Valitse</option>
                     {_.map(_.sortBy(options, el => el.name), this.createOption)}
                </select>
            </div>
        );
    }
});

var DetailsSelect = React.createClass({
    createOption: function(option) {
        return (
            <option key={option.id} value={option.id}>{option.details}</option>
        );
    },
    render: function() {
        const {details, onChange, options} = this.props,
              visibleStyle = {};

        // Only show the select if there are more than one option
        if (!options || _.keys(options).length <= 1)
            visibleStyle.display = 'none';

        return (
            <div className="custom-select" style={visibleStyle}>
                <select name="details" onChange={onChange} defaultValue={details}>
                    <option value="">Valitse</option>
                    {_.map(_.sortBy(options, el => el.order), this.createOption)}
                </select>
            </div>
        );
    }
});

var CarSelect = React.createClass({
    getInitialState: function () {
        return {
            brand: this.props.brand,
            model: this.props.model,
            details: this.props.details,
            orgBrand: this.props.brand,
            orgModel: this.props.model,
            orgDetails: this.props.details,
            edit: !(this.props.brand && this.props.model && this.props.details)
        };
    },
    getCar: function() {
        return {
            brand: this.state.brand,
            model: this.state.model,
            details: this.state.details
        };
    },
    getModels: function (brand) {
        if (!brand) {
            return '';
        }
        return this.props.cars[brand].models;
    },
    getDetails: function (model, brand) {
        if (!model || !brand) {
            return '';
        }
        return this.getModels(brand)[model].details;
    },
    getCarName: function() {
        var str = '',
            model;
        if (this.state.brand) {
            str += ' ' + this.props.cars[this.state.brand].name + ' ';
        }
        if (this.state.model) {
            model = this.getModels(this.state.brand)[this.state.model];
            str += model.name + ' ';
        }
        if (model && this.state.details) {
            str += model.details[this.state.details].details;
        }
        return str;
    },
    handleBrandChange: function (e) {
        this.setState({
            brand: e.target.value,
            model: '',
            details: ''
        });
    },
    handleModelChange: function (e) {
        var value = e.target.value,
            details = '';
        // If only one detail-option for the car model
        // select it automatically
        if (value) {
            var detailsOptions = this.getDetails(value, this.state.brand),
                detailsKeys = _.keys(detailsOptions);
            if (detailsKeys.length == 1) {
                details = detailsOptions[detailsKeys[0]].id;
            }
        }
        this.setState({
            model: e.target.value,
            details: details
        });
    },
    handleDetailsChange: function (e) {
        this.setState({
            details: e.target.value
        });
    },
    getCarOK: function() {
        return this.state.brand && this.state.model && this.state.details;
    },
    handleOK: function () {
        if (!this.getCarOK()) {
            return;
        }
        // Set orgStates only, because brand, model and details have already been set.
        this.setState({
            orgBrand: this.state.brand,
            orgModel: this.state.model,
            orgDetails: this.state.details,
            edit: false
        });
        this.props.onCarChange(this.getCar());
    },
    handleCancel: function () {
        this.setState({
            brand: this.state.orgBrand,
            model: this.state.orgModel,
            details: this.state.orgDetails,
            edit: false
        });
    },
    edit: function () {
        this.setState({
            edit: true
        });
    },
    render: function() {
        var el,
            carOK = this.getCarOK(),
            orgCarOK = this.state.orgBrand && this.state.orgModel && this.state.orgDetails;

        if (this.state.edit) {
            var buttonOK, buttonCancel;
            if (carOK) {
                buttonOK = (
                    <button className="btn btn-ok" onClick={this.handleOK}>
                      tallenna
                    </button>
                );
            } else {
                buttonOK = (
                    <button className="btn" disabled="disabled">
                      tallenna
                    </button>
                );
            }
            if (orgCarOK) {
                buttonCancel = (
                    <button className="btn btn-cancel" onClick={this.handleCancel}>
                      peruuta
                    </button>
                );
            } else {
                buttonCancel = (
                    <button className="btn" disabled="disabled">
                      peruuta
                    </button>
                );
            }

            el = (
                <div className="car-select edit">
                    <div className="buttons">
                        <i className="fa fa-car"></i>
                        <BrandSelect onChange={this.handleBrandChange}
                                     options={this.props.cars}
                                     brand={this.state.brand} />
                        <ModelSelect onChange={this.handleModelChange}
                                     options={this.getModels(this.state.brand)}
                                     model={this.state.model} />
                        <DetailsSelect onChange={this.handleDetailsChange}
                                       options={this.getDetails(this.state.model, this.state.brand)}
                                       details={this.state.details} />
                        <div className="ok-cancel">
                            {buttonOK}
                            {buttonCancel}
                        </div>
                    </div>
                </div>
            );
        } else {
            el = (
                <div className="car-select view">
                    <div className="car">
                        <span>
                          <i className="fa fa-car"></i>
                          {this.props.car_suitable
                           ? <span className="car-suitable"><i className="fa fa-check" /></span>
                           : null
                          }
                          {this.getCarName()}
                        </span>
                    </div>
                    {!this.props.car_suitable
                     ? <span className="car-unsuitable">
                          Tietokantamme mukaan vanne ei ole sopiva valitsemaasi autoon! Voit kuitenkin jatkaa tilauksen loppuun.
                       </span>
                     : null
                    }
                    <button className="btn btn-edit" onClick={this.edit}>
                      Muokkaa
                    </button>
                </div>
            );
        }
        return el;
    }
});

var WorkProductBox = React.createClass({
    onClick: function() {
        ShoppingCartManager.addWork({
            product: this.props.id,
            count: ~~this.props.needed
        });
        const productData = [{                        //  adding a product to a shopping cart.
            'name': this.props.work_type_text,
            'id': this.props.id,
            'price': this.props.unit_price,
            'brand': 'RENGAS TURKU',
            'category': 'Työ',
            'quantity': 1,
        }];
        dataLayer.push({
          'event': 'ecomAddToCart',
          'ecommerce': {
            'currencyCode': 'EUR',
            'add': {
                'products': productData
            }
          }
        });
    },
    render: function () {
        const countText = `${~~this.props.needed} kpl ` +
            `(${(this.props.unit_price * this.props.needed).toFixed(2)} €)`;

        return (
          <div className="work-box">
            <h3>{this.props.work_type_text}</h3>
            <div className="img">
                <img src={this.props.thumbnail} />
            </div>
            <div className="product-name">
                <div className="price">
                  {this.props.unit_price} € / kpl
                </div>
                <div className="count">
                  {this.props.title_extra} {countText}
                </div>
            </div>
            <div className="add">
              <button className="btn"
                      data-action="add-to-cart"
                      onClick={this.onClick}
                      data-id={this.props.id}>Lisää</button>
            </div>
          </div>
        );
    }
});

var ShoppingCartProductBox = React.createClass({
    getInitialState: function() {
        return {
            car: this.props.car || {brand: '', model: '', details: ''}
        };
    },
    countChange: function(count) {
        ShoppingCartManager.update({
            count: count,
            id: this.props.id
        });
    },
    handleCarChange: function(car) {
        this.setState({car: car});
        ShoppingCartManager.updateCar({
            id: this.props.id,
            brand: car.brand,
            model: car.model,
            details: car.details
        });
    },
    remove: function() {
        const tireTypes = {
            'summer': 'Kesärenkaat',
            'friction': 'Kitkarenkaat',
            'studded': 'Nastarenkaat',
            'truck': 'KA',
            'work': 'TK',
            'race': 'Kilparenkaat',
            'other': 'Muut renkaat',
        }

        let category = '';
        let brand = this.props.brand;
        let name = this.props.brand + ' ' + this.props.model;
        if (this.props.product_type == 'tire') {
          category = `${tireTypes[this.props.tire_type]}${this.props.used ? ' käytetyt' : ''}`;
        } else if (this.props.product_type == 'accessory') {
          category = 'Tarvikkeet';
        } else if (this.props.product_type == 'work') {
          category = 'Työ';
          name = this.props.work_type_text;
          brand = 'RENGAS TURKU';
        } else {
          category = `${this.props.wheel_type == 'alloy' ? 'Alumiinivanteet' : 'Peltivanteet'}${this.props.used ? ' käytetyt' : ''}`;
        }
        const productData = [{
            'name': name,
            'id': this.props.id,
            'price': this.props.unit_price,
            'brand': brand,
            'quantity': parseInt(this.props.count),
            'category': category,
        }];
        dataLayer.push({
          'event': 'ecomRemoveFromCart',
          'ecommerce': {
            'currencyCode': 'EUR',
            'remove': {
              'products':productData
            }
          }
        });
        ShoppingCartManager.remove({
            id: this.props.id
        });
    },
    tireDetails: function(tire) {
        var size;

        if (tire.size_type == 'normal') {
            size = tire.width + '/' + tire.profile + ' R' + tire.wheel_size;
        }
        else if (tire.size_type == 'inch_width') {
            size = tire.width_inch + '/' + tire.profile + ' R' + tire.wheel_size;
        }
        else if ( tire.size_type == 'inch') {
            size = '';
            if (tire.diameter)
                size += tire.diameter + 'x';
            size += tire.width_inch + '-' + tire.wheel_size;
        }
        return (
            <div>
                {size}&nbsp;{tire.load_index}&nbsp;{tire.speed_rating}<br />
                {tire.tire_type_text}
            </div>
        );
    },
    wheelDetails: function(wheel, set) {
        if (set !== true) {
            set = false;
        }
        var pcd = wheel.pcd;
        if (wheel.pcd2) {
            pcd += '/' + wheel.pcd2;
        }
        return (
            <div>
                {wheel.width}x{wheel.size}&quot;&nbsp;{pcd  || '?'}&nbsp;ET{wheel.et != '' && wheel.et != '0' && wheel.et != null ? wheel.et : '?'}&nbsp;
                Ø{ wheel.bore || '?'}

            </div>
        );
    },
    productDetails: function(product) {
        if (product.product_type == 'tire') {
            return this.tireDetails(product);
        }
        else if (product.product_type == 'wheel') {
            return this.wheelDetails(product);
        }
        else if (product.product_type == 'wheel_set') {
            return this.wheelDetails(product, true);
        }
        return '';
    },
    render: function() {
        var productName,
            details,
            deliveryTime,
            interval,
            is_wheel_set = this.props.product_type == 'wheel_set',
            set = is_wheel_set ? 'Sarja': '',
            stock = this.props.stock_total,
            extra = '';
        details = this.productDetails(this.props);

        if (this.props.product_type == 'work') {
            if (this.props.work_type_text == 'Muu työ') {
                productName = [
                    <div className="title">{this.props.title_extra}</div>,
                ];
            } else {
                productName = [
                    <div className="title">{this.props.work_type_text}</div>,
                    this.props.title_extra
                ];
            }
            interval = 1;
            stock = null;
        } else if (this.props.product_type == 'work') {
            productName = [
                <div className="title">{this.props.work_type_text}</div>,
                this.props.title_extra
            ];
            interval = 1;
            stock = null;
        } else {
            interval = 2;
            if (this.props.product_type == 'wheel') {
                interval = 4;
                if(this.props.non_stock_product) {
                    interval = 2;
                }
            } else if (['wheel_set', 'accessory'].includes(this.props.product_type)) {
                interval = 1;
            }
            productName = [
                <div className="brand">{this.props.brand}</div>,
                <div className="model">{this.props.model} <span className="wheel-set">{set}</span></div>
            ];
            if (this.props.delivery_time) {
                deliveryTime = (
                  <div className="delivery-time">
                    <span>Toimitusaika&nbsp;{this.props.delivery_time}
                    {this.props.supplier_estimated_delivery && this.props.supplier_estimated_delivery.includes('SAKSA') ? '&nbsp;SAKSA - JÄLKITOIMITUS' : ''}
                    </span>
                  </div>
                );
                stock = 1000;
            }
        }
        const hasImg = !this.props.thumbnail,
              imgSrc = hasImg ? '/static/nettivanne/webshop/img/rengas.svg' : this.props.thumbnail,
              imgClass = !hasImg ? '' : 'no-pic';

        let blankSelections = null;
        if (this.props.selected_et || this.props.selected_bore || this.props.selected_pcd) {
          blankSelections = (
            <div id="blankChoices">
              {this.props.selected_et && <span>ET {this.props.selected_et}</span>}
              {this.props.selected_bore && <span>Keskireikä {this.props.selected_bore}</span>}
              {this.props.selected_pcd && <span>Pulttikehä {this.props.selected_pcd}</span>}
            </div>
          );
        }

        return (
          <div className="cart-box product-box" data-id={this.props.id}>
            {extra}
            <div className="img">
                <img className={imgClass} src={imgSrc} />
            </div>
            <div className="product-name">
                <div><a href={this.props.url}>{productName}</a></div>
                {details}
                {blankSelections}
                {deliveryTime}
            </div>
            <div className="tire-size">
              <ProductHelpers.ItemCountControl count={this.props.count}
                                               unitPrice={this.props.unit_price}
                                               onChange={this.countChange}
                                               pricePerText={is_wheel_set ? 'sarja':'kpl'}
                                               pricePerTextPlural={is_wheel_set ? 'sarjaa':'kpl'}
                                               max={stock}
                                               interval={interval} />
            </div>
            <div className="remove">
                <button onClick={this.remove} className="btn btn-default btn-sm">
                    <i className="fa fa-trash-o"></i>
                </button>
            </div>
          </div>
        );
    }
});

var OfferCodeInput = React.createClass({
    getInitialState: function() {
        return {
            edit: false,
        };
    },
    changeState: function(changes) {
        this.setState(Object.assign({}, this.state, changes));
    },
    clear: function(ev) {
        var onChange = this.props.onChange;
        if (onChange != null)
            onChange(null);
        this.changeState({edit: false});
    },
    submit: function(ev) {
        var code = this.refs.input.value.trim(),
            onChange = this.props.onChange;

        if (onChange != null)
            onChange(code);
        this.changeState({edit: false});
    },
    render: function() {
        var code = this.props.offerCode;
        if (code != null && code.trim() != '')
            return this.renderCode();

        return this.renderEdit();
    },
    renderCode: function() {
        var code = this.props.offerCode;
        return (
            <div className={this.props.className}>
                <span>Etukoodisi: {code}</span>
                <button className="btn" onClick={this.clear}>
                    Poista
                </button>
            </div>
        );
    },
    renderEdit: function() {
        return (
            <div className={this.props.className}>
                <input className=""
                       placeholder="Syötä etukoodi"
                       ref="input"
                       type="text" />
                <button className="btn" onClick={this.submit}>
                    Tallenna
                </button>
                <p>Annamme toisinaan vakioasiakkaillemme alennuskoodin.</p>
                <p>Kaikki koodit ovat henkilökohtaisia ja kertakäyttöisiä.</p>
            </div>
        );
    },
});


export var ShoppingCartContents = React.createClass({
    empty: function (e) {
        ShoppingCartManager.empty();
    },
    shippingChange: function (e) {
        const shippingName = this.state.shipping.find(
          (s) => s.id == e.target.value
        ).name;
        ShoppingCartManager.updateShipping(e.target.value);
    },
    createCartRow: function (row) {
        return <ShoppingCartProductBox {...row} key={row.id}/>;
    },
    createWorkProductBox: function(product, i) {
        return <WorkProductBox {...product} key={i}/>;
    },
    carsSelected: function(rows) {
        if (!rows) {
            return false;
        }
        return !_.some(
            _.filter(rows, function(e){
                return (e.product_type == 'wheel' || e.product_type == 'wheel_set') && !e.is_blank;
            }), function (e) {
                return (!e.car);
            });
    },
    createCartSummary: function(cart, rows) {
        var checkout,
            motorsport = this.hasMotorsportProducts(rows);

        return (
            <div className="summary">
                <div className="summary-row clearfix">
                    <OfferCodeInput className="offer-code"
                                    offerCode={cart.offer_code}
                                    onChange={ShoppingCartManager.setOfferCode} />
                    <div className="total">
                        <div>Yhteensä:</div>
                        <div className="cart-total-price">{cart.total_price_text}&nbsp;€</div>
                    </div>
                </div>
            </div>
        );
    },
    createCartSummaryErrors: function(cart, rows, shippings) {
        const carsSelected = this.carsSelected(rows),
              hasShipping = cart.shipping,
              errors = [];

        if (!carsSelected)
            errors.push('Valitse auto vanteiden yhteensopivuuden varmistamiseksi, jotta voit edetä kassalla.');

        if (!hasShipping && !window.GIFT_CARD) {
            errors.push('Valitse toimitustapa.');
        } else {
            const shipping = _.first(
                    _.filter(shippings, s => s.id == cart.shipping)
            );
            if (!shipping && !window.GIFT_CARD)
                throw new Error(`Unknown shipping ID: ${cart.shipping}`);

            const hasMounts = _.some(rows, row => row.work_type == 'mounting');
            if (hasMounts && !shipping.shop)
                errors.push('Valitse toimitustavaksi nouto tai poista allelaitto ostoskorista.');
        }

        if (errors.length) {
          $('#checkout>.dim').show();
          $('#checkout').hide();
        } else {
          $('#checkout>.dim').hide();
          $('#checkout').show();
        }

        return _.map(errors, errorMessage => (
            <div className="additional-products-head error">
                {errorMessage}
            </div>
        ));
    },
    createAdditionalProductsHead: function () {
        if (!this.state.works || !this.state.works.length)
            return null;

        const additionalProducts = [];
        additionalProducts.push(
          <div className="additional-products-head">
            Voit tehdä ajanvarauksen, kun ostoskorissa on työtä ja olet valinnut toimitustavaksi noudon.
          </div>
        );

        if (_.find(this.state.works, {work_type: 'installation'})) {
            additionalProducts.push(
                <div className="additional-products-head">
                    Jos haluat renkaat asennettuna vanteille, valitse alta
                    myös renkaan asennus.
                </div>
            );
        }
        if (_.find(this.state.works, {work_type: 'mounting'})) {
            additionalProducts.push(
                <div className="additional-products-head">
                    Jos haluat renkaat asennettuna auton alle,
                    valitse alta myös allelaitto.
                </div>
            );
        }

        return additionalProducts;
    },
    hasMotorsportProducts: function (rows) {
        return _.filter(rows, function(r) {
            return 'tire_type' in r && r.tire_type == 'race';
        }).length > 0;
    },
    createCartShippingInput: function (shippingRow, motorsport, i) {
        if (!motorsport) {
            // Hide paddock pickup and tallinn pickup
            if (shippingRow.name.indexOf("Tallinn")!=-1 || shippingRow.name.indexOf("Paddock")!=-1) {
                return null;
            }
        }
        var text,
            checked = this.state.cart.shipping == shippingRow.id,
            className = "shipping-price";
        if (checked) {
            className += " checked";
        }
        if (shippingRow.shop) {
            text = 'Nouto (' + shippingRow.shop + ')';
        } else {
            text = shippingRow.name;
        }
        return (
            <div key={i}>
                <label>
                    <input type="radio"
                           value={shippingRow.id}
                           name="shipping"
                           onChange={this.shippingChange}
                           checked={this.state.cart.shipping == shippingRow.id} />
                    {text}
                </label>
                <span className={className}>
                    {shippingRow.price_text}&nbsp;€
                </span>
            </div>
        );
    },
    createCartShipping: function (shipping, rows) {
      if (window.GIFT_CARD) {
        return null;
      }
      var price = <div className="total-price">Valitse</div>,
          motorsport = this.hasMotorsportProducts(rows),
          createInput = this.createCartShippingInput;
        if (this.state.cart.shipping_price_text) {
            price = (
                <div className="total-price">
{this.state.cart.shipping_price_text}&nbsp;€
                </div>
            );
        }
        return (
            <div className="cart-shipping">
              <div className="product-name">
                <div className="title">{motorsport?"Toimitustapa / Shipping method":"Toimitustapa"}</div>
                  <div className="shipping-options">
                    {_.map(shipping, function (s) {
                      return createInput(s, motorsport)
                    })}
                  </div>
              </div>
            </div>
        );
    },
    getInitialState: function () {
        return ShoppingCartManager.getAll();
    },
    handleCarChange: function (id, car) {
      ShoppingCartManager.updateCar({
          id: id,
          brand: car.brand,
          model: car.model,
          details: car.details
      });
    },
    createCarSelects: function (rows) {
      let carSelects = [];
      _.forEach(rows, (row) => {
        if (_.contains(['wheel', 'wheel_set'], row.product_type)) {
          if (!row.is_blank) {
            carSelects.push(
                <CarSelect {...row.car} cars={window.car_data}
                                        onCarChange={this.handleCarChange.bind(null, row.id)}
                                        car_suitable={row.car_suitable} />
            );
          }
        }
      });
      return carSelects;
    },
    createBookingCalendar: function () {
      if (window.GIFT_CARD) {
        return null;
      }

      const selectedShipping = this.state.shipping.find(s => s.id == this.state.cart.shipping);

      let shop = null;
      if (selectedShipping && selectedShipping.shop_id)
        shop = {
          id: selectedShipping.shop_id,
          name: selectedShipping.shop,
        };

      return (
        <div id="shopping-cart-booking-calendar">
          <h2 className="title">Ajanvaraus</h2>
          <BookingCalendar shop={shop} rows={this.state.rows}/>
        </div>
      );
    },
    hasBlanks: function () {
      return this.state.rows.some(r => r.is_blank)
    },
    render: function () {
        const {cart, rows, shipping, works} = this.state;

        if (!rows.length) {
            return (
                <h2>Ostoskorisi on tyhjä</h2>
            );
        }

        if (this.hasBlanks()) {
          $("#blank-alert").css("display", "block");
        } else {
          $("#blank-alert").css("display", "none");
        }

        let hasWheels = false,
          hasTires = false;

        for (let row of rows) {
          if (_.contains(['wheel', 'wheel_set'], row.product_type)) {
            hasWheels = true;
          }

          if (_.contains(['tire'], row.product_type)) {
            hasTires = true;
          }
        }

        return (
          <div id="shopping-cart">
            <div className="dim"></div>
            {hasWheels && !hasTires && (
              <Infobox>
                <img className="icon" src="/static/nettivanne/webshop/img/tireico.png" />
                <div>
                  <h4>LISÄÄ RENKAAT VANTEIDEN RINNALLE ASENNETTUNA JA SAAT TÄYDELLLISEN RENGASPAKETIN SAMOILLA TOIMITUSKULUILLA!</h4>
                </div>
                  <a className="go-btn" href="/auton-renkaat/"><i className="fa fa-search"></i>&nbsp;Rengashaku</a>
                <img className='background-tires' src="/static/nettivanne/webshop/img/tiremarks.png" />
              </Infobox>
            )}
            <Infobox>
                <div>
                  <h4>Renkaiden asennus vanteille 0€!*</h4><br/>
                  <p>Kun ostat samalla kertaa renkaat ja vanteet, tarjoamme asennuksen ilmaiseksi!</p>
                  <p><i>Lisää alta ostoskoriin <b>Renkaan asennus</b> ja hinnat päivittyvät automaattisesti.</i></p>
                  <p><small>*Ei yhdistettävissä alennusryhmien etuihin.</small></p>
                </div>
            </Infobox>
            {this.createCarSelects(rows)}
            {_.map(rows, this.createCartRow)}
            {this.createCartShipping(shipping, rows)}
            {this.createAdditionalProductsHead()}
            {this.createCartSummary(cart, rows, shipping)}
            {_.map(works, this.createWorkProductBox)}
            {this.createCartSummaryErrors(cart, rows, shipping)}
            {
              this.state.rows.find(r => (r.product_type == 'work' && ['installation', 'mounting'].includes(r.work_type))) ? this.createBookingCalendar() : null
            }
          </div>
        );
    },
    componentDidMount: function () {
        ShoppingCartManager.on('change', this.update);
    },
    update: function () {
        this.setState(this.getInitialState());
    },
});

var Infobox = React.createClass({
  render: function () {
    return (
      <div className="infobox">{this.props.children}</div>
    );
  }
})

export var BookingCalendar = React.createClass({
  getInitialState: function () {
    return {
        isLoading: false,
        selectedSlot: null,
        skipped: false,
        slots: {},
        slotDuration: null,
        currentWeek: moment(new Date()).week(),
    };
  },
  componentDidMount: function () {
    this.clearBooking();
    this.fetchSlots(this.props.shop);
    this.summaryRef = el => {
      // Add 'floating' class to summary when it's following the window
      window.addEventListener('scroll', function() {
        const container = document.querySelector('.cart-calendar');
        const containerRect = container.getBoundingClientRect();
        const elementRect = el.getBoundingClientRect();
        const elementPositionFromBottom = containerRect.bottom - elementRect.bottom;

        const stickyClass = 'is-static';
        if (elementPositionFromBottom <= 0) {
            // Element is about to become sticky
            el.classList.add(stickyClass);
        } else {
            // Element is not sticky
            el.classList.remove(stickyClass);
        }
      });
    };
  },
  componentDidUpdate: function (prevProps) {
    const { shop, rows } = this.props;

    if (shop != prevProps.shop || rows != prevProps.rows) {
      this.clearBooking();
      this.fetchSlots(this.props.shop);
    }
  },
  fetchSlots: function (shop, week=null) {
    if (shop) {
      this.setState({isLoading: true})
      let url = `/_ajax/webshop/get_free_calendar_slots/${shop.id}`;

      if (this.props.orderId) {
        url += `?oid=${this.props.orderId}&`;
      } else {
        url += '?';
      }

      if (this.props.serviceId) {
        url += `prod_id=${this.props.serviceId}&`;
      }

      if (week) {
        url += `week=${week}`;
      }

      $.get(url, r => {
        if (r.slots)
          this.setState({
            slots: r.slots,
            slotDuration: r.slot_duration,
            isLoading: false,
            selectedSlot: null,
          });
      });
    }
  },
  clearBooking: function () {
    $.ajax({
      url: '/_ajax/webshop/delete_booking',
      type: 'DELETE',
    });
  },
  skipBooking: function () {
    this.clearBooking();
    let initialState = this.getInitialState();
    initialState['skipped'] = true;
    this.setState(initialState);
  },
  init: function () {
    this.setState(this.getInitialState());
    this.fetchSlots(this.props.shop);
  },
  selectSlot: function (slot) {
    const oid = this.props.orderId || null,
          payload = {oid: oid, time: slot[1], door: slot[0], duration: this.state.slotDuration};

    if (!this.props.noPreBook) {
      $.post('/_ajax/webshop/pre_book', payload, (r) => {
        this.setState({selectedSlot: slot});
        if (this.props.onSelect) {
          // Is this usefull at all?
          //this.props.onSelect();
        } else {
          onCheckoutOption(1, 'Valittu ajanvaraus');
        }
      });
    } else {
      if (this.props.onSelect) {
        this.props.onSelect(slot);

      }
      this.setState({selectedSlot: slot});
    }
  },
  render: function () {
    if (!this.props.shop)
      return (
        <div className="cart-calendar">
          <p className="cant-do-booking">Ajanvaraus ei ole mahdollinen valitsemallasi toimitustavalla.</p>
        </div>
      );
    if (this.state.skipped)
      return (
        <div className="cart-calendar">
          <p className="back-to-booking">
            <a onClick={() => {this.init()}}>
              <i className="fa fa-angle-double-left"></i> Takaisin ajanvaraukseen
            </a>
          </p>
          <br/>
          <p className="cant-do-booking">Ei ajanvarausta</p>
        </div>
      );

    return (
      <div className="cart-calendar">
        {!this.props.hideSkip && (<a className="skip-booking" onClick={this.skipBooking}>Ohita ajanvaraus <i className="fa fa-angle-double-right"></i></a>)}
        {!this.props.hideShop && (<p>Toimipiste: <b>{this.props.shop.name}</b></p>)}
        <br />
        { this.renderWeekSelector() }
        { this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : this.renderSlots() }
        { this.renderSummary() }
      </div>
    );
  },
  renderSummary: function () {
    const { selectedSlot, slotDuration } = this.state,
          { shop, stickySummary, onConfirm, confirmButtonText, summaryExtraText } = this.props;

    if (selectedSlot == null)
      return <p className="summary">Ei valittua aikaa.</p>;

    return (
      <p className={`summary ${stickySummary && 'sticky'} is-static`} ref={this.summaryRef}>
        Varaamme teille ajan <b>{ moment(selectedSlot[1]).lang('fi').format('DD.MM.YYYY [klo] HH.mm') }</b>{' '}
        osoitteeseen <b>{ shop.name }</b>. Työn kesto on noin <b>{ slotDuration }</b> minuuttia.
        <br />
        Varauksen tiedot lähetetään sähköpostiinne kun tilaus on maksettu.
        <br />
        <br />
        <i>{summaryExtraText || ''}</i>
        <br />
        { (onConfirm && confirmButtonText) && <a className="confirm-button" onClick={() => onConfirm(this.state.selectedSlot)}>{confirmButtonText}</a> }
      </p>
    );
  },
  renderWeekSelector: function () {
    const prevExtraCls = this.isCurrentWeekSelected() ? ' disabled' : '';
    return (
      <div className="week-selector">
        <a className={"prev" + prevExtraCls} onClick={() => this.prevWeek()}><i className="fa fa-angle-left"></i> Edellinen</a>
        <span className="current-week">Viikko {this.state.currentWeek}</span>
        <a className="next" onClick={() => this.nextWeek()}>Seuraava <i className="fa fa-angle-right"></i></a>
      </div>
    );
  },
  isCurrentWeekSelected: function () {
    return this.state.currentWeek == moment(new Date()).week();
  },
  prevWeek: function () {
    if (this.isCurrentWeekSelected() || this.state.isLoading) {
      return
    }
    const { currentWeek } = this.state;
    this.fetchSlots(this.props.shop, currentWeek - 1);
    this.setState({currentWeek: currentWeek - 1});
  },
  nextWeek: function () {
    if (this.state.isLoading) {
      return
    }
    const { currentWeek } = this.state;
    this.fetchSlots(this.props.shop, currentWeek + 1);
    this.setState({currentWeek: currentWeek + 1});
  },
  renderSlot: function (slot) {
    return (
      <div className={'slot' + (this.state.selectedSlot == slot ? ' selected' : '')}
           onClick={() => {
             this.selectSlot(slot);
             if (this.props.onSelect) {
               this.props.onSelect(slot);
             }
           }}
           key={slot[1]}>
        {moment(slot[1]).format("HH:mm")}
      </div>
    )
  },
  renderSlots: function () {
    const { slots } = this.state;
    return (
      <div className="slots">
        {Object.keys(slots).map(day => (
            <div className={'day' + (moment(day).isSame(moment(new Date()), 'day') ? ' today' : '')}
                 key={day}>
              <p className="day-title">
                { moment(day).lang('fi').format("ddd") }
                <br/>
                { moment(day).format("DD.MM.") }
              </p>
              { slots[day].length > 0
                ? slots[day].map(slot => this.renderSlot(slot))
                : <div className="empty-day"></div>
              }
            </div>
          ))
        }
      </div>
    );
  }
});

export var PaymentOptions = React.createClass({
  render: function () {
    const bankEls = _.map(this.props.banks.providers, (b) => {
      const bankFields = _.map(b.parameters, ({name, value}) => {
        return <input type="hidden" name={name} value={value} />;
      });
      return (
        <div className="payment-option">
          <form action={b.url} method="POST">
            {bankFields}
            <span onClick={() => sendEnhancedAnalytics(5, `Maksutapa: ${b.name}`)}>
              <input type="image" src={b.icon} />
            </span>
            <div>{b.name}</div>
          </form>
        </div>
      );
    });
    return (
      <div>
        <h2 className="title">Valitse maksutapa</h2>
        <div className="payment-options">
          {bankEls}
        </div>
      </div>
    );
  },
});

export var ShoppingCartManager = (function () {
    var ee = new EventEmitter(),
        shoppingCartData,
        baseUrl = '/_ajax/shopping-cart/';

    var hasMotorsportProducts = function (row) {
        return row.product && row.product.details &&
            row.product.details.tire_size_coded &&
            row.product.details.tire_size_coded.endsWith("6");
    };

    var onAddSuccess = function (data) {
        ee.trigger('addSuccess');
        shoppingCartData.cart = data.cart;
        var motorsport = hasMotorsportProducts(data.row);
        if (data.cart.item_count !== 0) {
            const productList = $('#search-stuff').length ? 'product-list' : '';
            const opts = {
              open: (e, m, o) => {
                ProductHelpers.calculateNotificationLocation(e, productList);
              },
              life: 5000,
              pool: 1,
            };
            if (motorsport) {
                $.jGrowl('Lisätty ostoskoriin<br>Added to Cart<br><br><a href="/ostoskori/"><i class="fa fa-shopping-cart"></i> Kassalle / to cart</a>', opts);
            } else {
                $.jGrowl('Lisätty ostoskoriin<br><br><a href="/ostoskori/"><i class="fa fa-shopping-cart"></i> Kassalle</a>', opts);
            }
            fbq('track', 'AddToCart');
        }
        refreshCart();
    };
    var onAddError = function () {
        ee.trigger('addError');
        refreshCart();
    };
    var onUpdate = function (data) {
        shoppingCartData.cart = data.cart;
    };
    var onShippingUpdateSuccess = function (data) {
        onUpdate(data);
        triggerChange();
    };
    var onUpdateSuccess = function (data, rowId) {
        onUpdate(data);
        shoppingCartData.cart = data.cart;
        if (data.row) {
            var row = _.findWhere(shoppingCartData.rows, {id: data.row.id});
            _.extend(row, _.pick(data.row, ['count', 'stock_total']));
        } else if (rowId) {
            shoppingCartData.rows = _.reject(shoppingCartData.rows, {id: rowId});
        }
        refreshCart();
    };
    var onCarUpdateSuccess = function (data) {
        if (data.row) {
            var row = _.findWhere(shoppingCartData.rows, {id: data.row});
            _.extend(row, {car_suitable: data.car_suitable, car: data.car});
            triggerChange();
        }
    };
    var setData = function (data) {
        shoppingCartData = data;
    };
    var setOfferCode = function (code) {
        $.post(baseUrl + 'offer_code', {offer_code: code})
         .done(onReceiveCart)
         .fail(function(err) { /* TODO */ })
         .always(done);
    };
    var onReceiveCart = function (data) {
        setData(data);
        triggerChange();
    };
    var refreshCart = function () {
        $.get(baseUrl + 'webshop_get_cart')
         .done(onReceiveCart)
         .always(done);
    };
    var triggerChange = function (data) {
        ee.trigger('change');
    };

    var wait = function () {
    };

    var done = function () {
    };

    var add = function (data) {
        var type = 'webshop_product';
        return $.post(baseUrl + type, data)
                .done(onAddSuccess)
                .fail(onAddError)
                .always(done);
    };

    var addWork = function (data) {
        var type = 'webshop_work';
        return $.post(baseUrl + type, data)
                .done(onAddSuccess)
                .always(done);
    };

    var onEmptySuccess = function () {
        ee.trigger('change');
        refreshCart();
        if (window.google_trackConversion) {
            var custom_params = _.extend(
                _.clone(window.google_custom_params),
                {dynx_pagetype: 'cancel'}
            );
            window.google_trackConversion({
                google_conversion_id: window.google_conversion_id,
                google_custom_params: custom_params,
                google_remarketing_only: window.google_remarketing_only
            });
        }
    };
    var empty = function () {
        $.post(baseUrl + 'webshop_empty', {
            method: 'POST'
        }).done(onEmptySuccess);
    };
    var update = function (data) {
        var type ='webshop_product',
            method = 'PUT';
        if (data.count == 0) {
            method = 'DELETE';
        }
        return $.ajax({
            url: baseUrl + type + '/' + data.id,
            method: method,
            data: data})
                .done(_.partial(onUpdateSuccess, _, data.id))
                .always(done);
    };
    var updateCar = function (data) {
        return $.ajax({
            url: baseUrl + 'rows/' + data.id + '/webshop_car',
            method: 'POST',
            data: data})
                .done(_.partial(onCarUpdateSuccess, _, data.id))
                .always(done);
    };
    return {
        on: ee.on.bind(ee),
        off: ee.off.bind(ee),
        getAll: function () {
            return shoppingCartData;
        },
        setData: setData,
        setOfferCode: setOfferCode,
        add: function (data) {
            add(data);
        },
        addWork: function (data) {
            addWork(data);
        },
        update: function (data) {
            update(data);
        },
        updateCar: function (data) {
            updateCar(data);
        },
        updateShipping: function(id) {
            return $.post(baseUrl + 'webshop_shipping/' + id)
                    .done(onShippingUpdateSuccess)
                    .always(done);
        },
        remove: function (data) {
            update($.extend(data, {count: 0}));
        },
        empty: function () {
            empty();
        }
    };
})();

export default {
  NavShoppingCart,
  ProductAddToCart,
  ShoppingCartContents,
  ShoppingCartManager,
  PaymentOptions,
  blankDialog,
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/shopping-cart-manager.js
 **/